/**
 * Takes a rhythm skill string and converts to music. Assumes 12/8 for compound and 4/4 for simple
 * to assure there's always enough room
 * @param skillString in the format C(ompound)/S(imple)/H(cut):e.ser etc...
 */
export function rhythmSkillStringToRhythmString(skillString: string): string {
  const meterMatch = skillString.slice(0, 1).match(/[C,S,H]/);
  if (!Array.isArray(meterMatch)) {
    throw Error('skillString must begin with C, S or H to get music from a skill string');
  }
  const meterType = meterMatch[0];
  let meter;
  switch (meterType) {
    case 'C':
      meter = '12/8';
      break;
    case 'H':
      meter = '4/2';
      break;
    case 'S':
      meter = '4/4';
      break;
  }
  const noteString = skillString
    .slice(2)
    .split('')
    .reduce((accum, char) => {
      // characters that don't indicate a new note are: . r t, all others require a space before them
      // eslint-disable-next-line no-useless-escape
      if (char.search(/[r,t,\.]/) === -1) return `${accum} ${char}`;
      return `${accum}${char}`;
    });
  return `${meter}:${noteString}`;
}
